import { FC, useState } from 'react'

import generator from 'generate-password'

import { Txt, StandardButton } from 'src/components/atoms'
import { ForceUpdatePasswordModal, PasswordCopyEmailModal } from 'src/components/organisms'

import { UserEntity } from 'src/types'

type Props = {
  user: UserEntity
  afterUpdatePassword?: () => void
  className?: string
}

export const ForceUpdatePassword: FC<Props> = ({ user, afterUpdatePassword, className }) => {
  const [isForceUpdatePasswordOpen, setIsForceUpdatePasswordOpen] = useState(false)
  const [isCopyEmailPasswordOpen, setIsCopyEmailPasswordOpen] = useState(false)
  const [password, setPassword] = useState('')

  const generatePassword = () => {
    return generator.generate({
      numbers: true,
    })
  }

  const handleOnClick = async () => {
    setPassword(generatePassword())
    setIsForceUpdatePasswordOpen(true)
  }

  const handleOnClose = () => {
    setIsCopyEmailPasswordOpen(false)
  }

  return (
    <div className={className}>
      <div className="tw-flex tw-items-center tw-justify-between">
        <Txt sizeType="s" className="tw-text-standardText-secondary">
          パスワードリセットするとパスワードが自動生成されます。リセット後、パスワードをユーザーのメールアドレス宛に通知可能です。
        </Txt>
        <StandardButton
          buttonType="secondary"
          text="リセット"
          appendIconPath="refresh-ccw/soft/line"
          onClick={handleOnClick}
          className="tw-w-[6.5rem] tw-shrink-0 tw-ml-s-1"
        />
      </div>

      <ForceUpdatePasswordModal
        user={user}
        password={password}
        isOpen={isForceUpdatePasswordOpen}
        onClose={() => setIsForceUpdatePasswordOpen(false)}
        onSuccess={() => setIsCopyEmailPasswordOpen(true)}
        afterUpdate={afterUpdatePassword}
      />

      <PasswordCopyEmailModal
        isOpen={isCopyEmailPasswordOpen}
        user={user}
        password={password}
        onClose={handleOnClose}
        afterUpdate={afterUpdatePassword}
      />
    </div>
  )
}
